/* R40 contact truth boundary. No fetch, email provider, timers or payment calls.
 * Preview: local validation only. Shopify: native browser POST, never AJAX.
 * A platform-rendered result is not an email-delivery receipt.
 */
(function (root, factory) {
  "use strict";
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root && root.document) api.mount(root);
})(typeof window === "undefined" ? null : window, function () {
  "use strict";
  var TTL = 30 * 60 * 1000;
  var PREFIX = "vp_contact_recovery_v1:";
  var FIELDS = { "contact[name]": 200, "contact[email]": 320, "contact[body]": 12000,
    "contact[figures]": 60, "contact[deadline]": 80, "contact[occasion]": 200, "contact[budget]": 80 };
  /* 欧洲改造 leftovers/misc（裁决 65）：状态文案走 window.VP_I18N（snippets/vp-i18n-js，只在 vp_intl 为真时输出；
     本文件在 layout 里 defer 加载，排在那段内联脚本之后）。美国 / JP 没有 VP_I18N，T() 返回原英文，COPY 逐字不变。 */
  function T(k, f) { var d = typeof window !== "undefined" && window.VP_I18N; return d && typeof d[k] === "string" ? d[k] : f; }
  var COPY = {
    preview: T('js.contact.preview', "Preview only — this page does not send requests. Your entries stay in this form."),
    checked: T('js.contact.checked', "Not sent. Your request passes this preview's checks. Keep your entries here or use the connected store form."),
    invalid: T('js.contact.invalid', "Not sent. Please complete the highlighted required fields. Your entries have not been cleared."),
    idle: T('js.contact.idle', "Send your brief through the store's contact form. This is not a purchase or payment."),
    pending: T('js.contact.pending', "Continuing to the store submission process. Complete any verification shown. This is not a delivery confirmation."),
    error: T('js.contact.error', "The store reported a form error. Review the error details and your entries before trying again."),
    processed: T('js.contact.processed', "Thanks \u2014 your request reached us. We reply within 2\u20133 business days, usually sooner. Nothing has been charged."),
    unverified: T('js.contact.unverified', "A return URL is not a submission receipt. This page cannot confirm that a new request was sent."),
    interrupted: T('js.contact.interrupted', "The submission outcome is not confirmed here. Check the store response before trying again; your entries have not been cleared.")
  };
  function value(form, name) {
    var field = form.elements && form.elements[name];
    return field && typeof field.value === "string" ? field.value : "";
  }
  function nativeForm(form, location) {
    if (form.getAttribute("data-contact-mode") !== "shopify" || form.getAttribute("data-contact-provider") !== "shopify-liquid") return false;
    if ((form.getAttribute("method") || "get").toLowerCase() !== "post" || value(form, "form_type") !== "contact") return false;
    try {
      var here = new URL(location.href), action = new URL(form.getAttribute("action") || "", here);
      return here.protocol === "https:" && action.protocol === "https:" && action.origin === here.origin &&
        !action.username && !action.password && !action.search && /^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?contact\/?$/i.test(action.pathname);
    } catch (_) { return false; }
  }
  function identity(form, location) {
    var url = new URL(location.href);
    return { id: form.id || form.getAttribute("id") || "custom-request", origin: url.origin, path: url.pathname,
      world: value(form, "contact[world]"), design: value(form, "contact[selected_design]") };
  }
  function sameContext(saved, context) {
    return !!saved && saved.id === context.id && saved.origin === context.origin && saved.path === context.path &&
      saved.world === context.world && (!context.design || saved.design === context.design);
  }
  function recovery(raw, context, now) {
    try {
      var saved = JSON.parse(raw);
      if (!saved || saved.version !== 1 || !Number.isFinite(saved.at) || now < saved.at || now - saved.at >= TTL || !sameContext(saved, context)) return null;
      if (!saved.fields || typeof saved.fields !== "object") return null;
      var fields = {};
      Object.keys(FIELDS).forEach(function (name) {
        if (typeof saved.fields[name] === "string") fields[name] = saved.fields[name].slice(0, FIELDS[name]);
      });
      return Object.assign({}, context, { version: 1, at: saved.at, fields: fields });
    } catch (_) { return null; }
  }
  function snapshot(form, context, now) {
    var fields = {};
    Object.keys(FIELDS).forEach(function (name) {
      if (form.elements && form.elements[name]) fields[name] = value(form, name).slice(0, FIELDS[name]);
    });
    return Object.assign({}, context, { version: 1, at: now, fields: fields });
  }
  function mount(win) {
    var doc = win.document;
    if (!doc || !doc.querySelectorAll) return [];
    return Array.from(doc.querySelectorAll("form[data-contact-truth]")).map(function (form) {
      if (form.__vpContactTruth) return form.__vpContactTruth;
      var listeners = [], disposed = false, pending = false;
      var mode = nativeForm(form, win.location) ? "shopify" : "preview";
      var status = form.querySelector("[data-contact-status]");
      if (!status) {
        status = doc.createElement("p"); status.setAttribute("data-contact-status", "");
        form.appendChild(status);
      }
      status.setAttribute("role", "status"); status.setAttribute("aria-live", "polite");
      status.setAttribute("aria-atomic", "true"); status.hidden = false;
      var button = form.querySelector('[type="submit"]');
      var originalLabel = button ? button.textContent : "";
      if (button) { button.disabled = false; if (mode === "preview") button.textContent = T('js.contact.check_preview', "Check my request (preview)"); }
      var server = form.querySelector("[data-contact-server-result]");
      var serverState = server ? server.getAttribute("data-contact-server-result") : "idle";
      function setState(state, message) {
        form.setAttribute("data-contact-state", state);
        status.textContent = message;
      }
      function listen(target, event, handler, options) {
        if (!target || !target.addEventListener) return;
        target.addEventListener(event, handler, options);
        listeners.push(function () { target.removeEventListener(event, handler, options); });
      }
      function now() { return win.Date && win.Date.now ? win.Date.now() : Date.now(); }
      function storageKey(context) { return PREFIX + context.id; }
      function readRecovery(context) {
        try { return recovery(win.sessionStorage.getItem(storageKey(context)), context, now()); }
        catch (_) { return null; }
      }
      function dropRecovery(context) {
        try { win.sessionStorage.removeItem(storageKey(context)); } catch (_) {}
      }
      function saveRecovery(context) {
        try { win.sessionStorage.setItem(storageKey(context), JSON.stringify(snapshot(form, context, now()))); return true; }
        catch (_) { return false; }
      }
      function restoreFields(saved) {
        var count = 0;
        Object.keys(saved.fields).forEach(function (name) {
          var field = form.elements && form.elements[name];
          // Never overwrite platform-returned values, browser restoration, or new text.
          if (!field || value(form, name)) return;
          if (field.options && !Array.from(field.options).some(function (option) { return option.value === saved.fields[name]; })) return;
          field.value = saved.fields[name]; count++;
        });
        return count;
      }
      var initialContext = identity(form, win.location), saved = mode === "shopify" ? readRecovery(initialContext) : null;
      if (mode === "preview") setState("preview", COPY.preview);
      else if (serverState === "error") {
        if (saved) restoreFields(saved);
        setState("error", COPY.error);
      } else if (serverState === "processed") {
        // 2026-09-20：原来还要求本标签页有一份上下文完全一致的快照才肯报成功，
        // 但 sameContext() 会比 contact[world] / contact[selected_design]，
        // 而这两个隐藏字段是运行时才填的 —— 回跳后取 identity() 时还是空串，
        // 于是永远对不上，成功文案成了死代码，客户看到的是一句否定句。
        // form.posted_successfully? 只在真的发生过 POST 时才渲染（GET 同一个 URL
        // 不会出现），本身就不可伪造，不需要再叠一层本地快照。
        setState("processed", COPY.processed);
        dropRecovery(initialContext);
      } else {
        if (saved) restoreFields(saved);
        setState(saved ? "interrupted" : "idle", saved ? COPY.interrupted : COPY.idle);
      }
      listen(form, "invalid", function () { setState("invalid", COPY.invalid); }, true);
      listen(form, "submit", function (event) {
        if (disposed) return;
        if (!form.checkValidity()) {
          event.preventDefault(); if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          setState("invalid", COPY.invalid); form.reportValidity(); return;
        }
        if (mode !== "shopify" || !nativeForm(form, win.location)) {
          event.preventDefault(); if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          setState("preview-checked", COPY.checked); return;
        }
        if (event.defaultPrevented) { setState("interrupted", COPY.interrupted); return; }
        pending = true;
        var retained = saveRecovery(identity(form, win.location));
        setState("pending", COPY.pending + " " + (retained ? T('js.contact.pending_retained', "A recovery copy in this tab is eligible for restoration for 30 minutes. Clear it below or close this tab to remove it.") : T('js.contact.pending_no_copy', "This browser cannot retain a recovery copy; keep a copy of your message before leaving.")));
        // Deliberately no preventDefault, form.submit, fetch, reset or disabled
        // submitter. Shopify owns the normal POST and any anti-spam challenge.
      }, true);
      listen(form, "input", function () {
        if (pending) return;
        setState(mode === "preview" ? "preview" : "idle", mode === "preview" ? COPY.preview : COPY.idle);
      });
      listen(win, "pageshow", function (event) {
        if (!event.persisted || !pending) return;
        pending = false; setState("interrupted", COPY.interrupted);
      });
      var clear = form.querySelector("[data-contact-clear-recovery]");
      // 这颗按钮原来常驻可见、没草稿也能点，点了还会把说明文案顶掉。
      // 只有真存着草稿时才露出来。
      if (clear) {
        clear.hidden = !saved;
        if (saved) clear.hidden = false;
      }
      listen(clear, "click", function () {
        if (clear) clear.hidden = true;
        dropRecovery(identity(form, win.location));
        setState("recovery-cleared", T('js.contact.recovery_cleared', "The recovery copy in this tab was removed. Your current form entries are unchanged."));
      });
      var controller = { mode: mode, dispose: function () {
        if (disposed) return;
        disposed = true; listeners.forEach(function (remove) { remove(); });
        if (button) { button.disabled = false; button.textContent = originalLabel; }
        delete form.__vpContactTruth;
      } };
      form.__vpContactTruth = controller;
      return controller;
    });
  }
  return { mount: mount, nativeForm: nativeForm, recovery: recovery, snapshot: snapshot, TTL: TTL, PREFIX: PREFIX, COPY: COPY };
});
